import './assets/main.css'

import { createApp } from 'vue'
import App from './App.vue'
import setupApp from '@/utils/setupApp'

if (import.meta.env.PROD) {
  window.addEventListener('vite:preloadError', (event) => {
    const error = (event as Event & { payload?: unknown }).payload

    if (!(error instanceof Error) || !error.message.startsWith('Unable to preload CSS for ')) {
      return
    }

    const reloadKey = 'css-preload-reload-error'

    try {
      if (sessionStorage.getItem(reloadKey) === error.message) {
        return
      }

      sessionStorage.setItem(reloadKey, error.message)
    } catch {
      return
    }

    event.preventDefault()
    window.location.reload()
  })
}

setupApp(createApp(App)).then((app) => app.mount('#app'))
